import { Button, Container, LinearProgress } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import InputForm from "./InputForm";
import logo from "../../../assets/cosmo-logo-gray.svg";
import styles from "./MobileView.module.css";
import ScanQrCode from "./ScanQrCode";
import ActivationFormContext from "../../../store/activation-form-context";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSearchParams } from "react-router-dom";

const MobileView = () => {
  const [showForm, setShowForm] = useState<boolean>();
  const [searchParams] = useSearchParams();

  const { disableSubmit, formSubmitHandler } = useContext(ActivationFormContext);

  useEffect(() => {
    const imei = searchParams.get("imei");

    const onlyNums = imei?.replace(/[^0-9]/g, "");
    if (onlyNums && onlyNums.length <= 15) {
      setShowForm(true);
    } else {
      setShowForm(false);
    }
  }, [searchParams]);

  const handleBackClick = () => {
    if (showForm) {
      setShowForm(false);
    } else {
      window.history.back();
    }
  };

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        px: "0px",
        overflow: "clip",
        maxHeight: "100%",
      }}
      disableGutters
    >
      <img src={logo} className={styles.logo} alt="cosmo logo" />
      <Container
        sx={{
          px: "0px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          padding: "15px 8px",
        }}
      >
        <Button sx={{ p: "0px", fontWeight: 500, fontSize: "13px" }} color="primary" startIcon={<ChevronLeftIcon />} disabled={true} onClick={handleBackClick}>
          Back
        </Button>
        <LinearProgress value={20} variant="determinate" sx={{ width: "80%", mx: "5%" }} />
        <Button sx={{ p: "0px", fontWeight: 500, fontSize: "13px" }} disabled={disableSubmit} onClick={formSubmitHandler}>
          Next
        </Button>
      </Container>
      {showForm === true && (
        <Container sx={{ px: "30px", overflow: "scroll" }}>
          <InputForm />
        </Container>
      )}
      {showForm === false && <ScanQrCode onShowForm={() => setShowForm(true)} />}
    </Container>
  );
};
export default MobileView;
